(function () {
  'use strict';

  angular
    .module('app.sidebar', ['app.user-switcher']);
})();
